import {
  Box,
  Collapse,
  IconButton,
  Pagination,
  Paper,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  Tooltip,
  Typography,
} from "@mui/material";
import classNames from "classnames";
import parser from "html-react-parser";
import React, { useEffect, useRef, useState } from "react";
import { BsDot } from "react-icons/bs";
import { ImNewTab } from "react-icons/im";
import { MdInfoOutline, MdKeyboardArrowUp, MdOutlineFileDownload, MdOutlineKeyboardArrowDown } from "react-icons/md";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Button, Col, Nav, NavItem, NavLink, Row, Spinner, Table } from "reactstrap";
import PlaceholderImg from "../../assets/placeholder-img.png";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  PaginationComponent,
  PreviewCard,
} from "../../components/Component";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import {
  getInventoryReportExport,
  getInventoryReports,
  setInventoryFilter,
  setInventoryType,
} from "../../redux/Apislices/reportSlice";
import { extractNumber, USDollar } from "../../utils/Utils";
import CollapsibleTable from "./CollaspableTable";
import styles from "./inventory.module.scss";
import InventoryForm from "./InventoryForm";

const InventoryReport = () => {
  const dispatch = useDispatch();
  const { reports } = useSelector((state) => ({
    reports: state.report.inventoryReport,
  }));

  const [tabData, setTabData] = useState([
    { id: 1, label: "Developements", value: "presale" },
    { id: 2, label: "Assignments", value: "assignment" },
    // { id: 3, label: "MLS Listings", value: "mls" },
  ]);

  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("");
  const [loading, setLoading] = useState(false);
  const controllerRef = useRef(null);

  const handleSort = (property) => {
    const isAsc = orderBy === property && order === "asc";

    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);

    let payload = { sort: property, sortOrder: isAsc ? "desc" : "asc" };

    if (reports?.localFilter) payload = { ...reports?.localFilter, ...payload };
    else payload = { ...payload, type: reports?.type };

    handleInventoryGet(payload);
  };

  const handleInventoryExport = async () => {
    setLoading(true);
    await dispatch(getInventoryReportExport({ ...reports?.filter, rawFilter: reports?.localFilter })).then((res) => {
      console.log("res: ", res);
      if (res) {
        const url = window.URL.createObjectURL(new Blob([res]));
        console.log("url: ", url);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `inventory_report_${reports?.type}_${new Date().toISOString().split("T")[0]}.xlsx`
        );
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } else {
        console.error("Download failed or returned empty.");
      }
      setLoading(false);
    });
  };
  const handleInventoryGet = async (payload) => {
    if (controllerRef.current) controllerRef.current.abort();

    const controller = new AbortController();
    controllerRef.current = controller;

    dispatch(getInventoryReports({ query: payload, signal: controller.signal }));
  };

  useEffect(() => {
    let payload = { ...reports?.localFilter };
    if (reports?.localFilter?.type === "assignment")
      payload = { ...payload, assignmentStatus: payload?.assignmentStatus || "active" };

    handleInventoryGet(payload);

    return () => {
      if (controllerRef.current) controllerRef.current.abort();
    };
  }, [reports?.localFilter]);

  return (
    <>
      <Head title="Inventory Search" />

      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag={"h1"}>
                Inventory Search
              </BlockTitle>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block className={"mt-2"}>
          <Row>
            <Col lg={12}>
              <InventoryForm handleInventoryGet={handleInventoryGet} />
            </Col>
          </Row>

          <PreviewCard bodyClass={"px-0"}>
            <div className="d-flex justify-end align-items-center pr-4">
              <Button onClick={handleInventoryExport} disabled={loading} className="btn btn-primary">
                {loading ? (
                  <Spinner size="sm" color="white" />
                ) : (
                  <>
                    Export
                    <MdOutlineFileDownload className="ml-2" />
                  </>
                )}
              </Button>
            </div>
            <Nav tabs className={classNames("px-4", styles.nav)}>
              {tabData?.map((li) => (
                <NavItem key={li?.id}>
                  <NavLink
                    tag="div"
                    className={classNames({ active: reports?.type === li?.value })}
                    style={{ cursor: "pointer", padding: "10px" }}
                    onClick={(ev) => {
                      ev.preventDefault();
                      let payload = { ...reports?.localFilter, type: li?.value };
                      dispatch(setInventoryType(li?.value));
                      dispatch(setInventoryFilter(payload));
                      // dispatch(getInventoryReports(payload));
                      handleInventoryGet(payload);
                    }}
                  >
                    <div>
                      {li?.label}{" "}
                      {reports?.type === li?.value && reports?.total?.total ? (
                        <span>({reports?.total?.total})</span>
                      ) : null}
                    </div>
                  </NavLink>
                </NavItem>
              ))}
            </Nav>

            {reports?.loading ? (
              <div className="text-center mt-4">
                <Spinner color="primary" />
              </div>
            ) : (
              <div className="my-3">
                {reports?.type === "presale" && reports?.data?.length > 0 && (
                  <PresaleTable
                    order={order}
                    orderBy={orderBy}
                    handleSort={handleSort}
                    handleInventoryGet={handleInventoryGet}
                  />
                )}
                {reports?.type === "assignment" && reports?.data?.length > 0 && (
                  <AssignmentTable
                    order={order}
                    orderBy={orderBy}
                    handleSort={handleSort}
                    handleInventoryGet={handleInventoryGet}
                  />
                )}
                {reports?.success && reports?.data?.length === 0 && (
                  <div className="text-center mt-4">
                    <p>No data available</p>
                  </div>
                )}
              </div>
            )}
          </PreviewCard>
        </Block>

        {/* <div className="mt-5">
          <CollapsibleTable />
        </div> */}
      </Content>
    </>
  );
};

export const PresaleTable = ({ order, orderBy, handleSort, handleInventoryGet }) => {
  const dispatch = useDispatch();
  const { reports } = useSelector((state) => ({
    reports: state.report.inventoryReport,
  }));

  const mainDivRef = useRef(null);

  return (
    <TableContainer component={Paper}>
      <Table
        sx={{ minWidth: 664, width: "100%" }}
        aria-label="simple table"
        responsive
        ref={mainDivRef}
        className={styles.presaleTable}
      >
        <TableHead>
          <TableRow>
            <TableCell sx={{ minWidth: 300 }}>Name</TableCell>
            <TableCell sx={{ minWidth: 200 }} rowSpan={1}>
              Floor Plan
            </TableCell>
            <TableCell sx={{ minWidth: 150 }} colSpan={2} align="center">
              Floor Area
            </TableCell>
            <TableCell sx={{ minWidth: 150 }} colSpan={2} align="center">
              Price Range
            </TableCell>
            <TableCell sx={{ minWidth: 150 }} colSpan={2} align="center">
              Price/Sqft
            </TableCell>
            <TableCell sx={{ minWidth: 100 }} rowSpan={1}>
              Incentive
            </TableCell>
            <TableCell sx={{ minWidth: 100 }} colSpan={2} align="center">
              Beds
            </TableCell>
            <TableCell sx={{ minWidth: 100 }} colSpan={2} align="center">
              Baths
            </TableCell>
            <TableCell sx={{ minWidth: 100 }} rowSpan={1}>
              Deposit
            </TableCell>
            <TableCell sx={{ minWidth: 100 }} rowSpan={1}>
              Completion
            </TableCell>
            <TableCell sx={{ minWidth: 100 }} rowSpan={1}>
              Commission
            </TableCell>
            <TableCell sx={{ minWidth: 100 }} rowSpan={1}>
              Contact
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell></TableCell>
            <TableCell></TableCell>
            <TableCell>
              <TableSortLabel
                active={orderBy === "floorAreaMin"}
                direction={orderBy === "floorAreaMin" ? order : "asc"}
                onClick={() => handleSort("floorAreaMin")}
              >
                Min
              </TableSortLabel>
            </TableCell>
            <TableCell>
              <TableSortLabel
                active={orderBy === "floorAreaMax"}
                direction={orderBy === "floorAreaMax" ? order : "asc"}
                onClick={() => handleSort("floorAreaMax")}
              >
                Max
              </TableSortLabel>
            </TableCell>
            <TableCell>
              <TableSortLabel
                active={orderBy === "priceRangeMin"}
                direction={orderBy === "priceRangeMin" ? order : "asc"}
                onClick={() => handleSort("priceRangeMin")}
              >
                Min
              </TableSortLabel>
            </TableCell>
            <TableCell>
              <TableSortLabel
                active={orderBy === "priceRangeMax"}
                direction={orderBy === "priceRangeMax" ? order : "asc"}
                onClick={() => handleSort("priceRangeMax")}
              >
                Max
              </TableSortLabel>
            </TableCell>
            <TableCell>
              <TableSortLabel
                active={orderBy === "priceSqftMin"}
                direction={orderBy === "priceSqftMin" ? order : "asc"}
                onClick={() => handleSort("priceSqftMin")}
              >
                Min
              </TableSortLabel>
            </TableCell>
            <TableCell>
              <TableSortLabel
                active={orderBy === "priceSqftMax"}
                direction={orderBy === "priceSqftMax" ? order : "asc"}
                onClick={() => handleSort("priceSqftMax")}
              >
                Max
              </TableSortLabel>
            </TableCell>

            <TableCell />

            <TableCell>
              <TableSortLabel
                active={orderBy === "bedroomsMin"}
                direction={orderBy === "bedroomsMin" ? order : "asc"}
                onClick={() => handleSort("bedroomsMin")}
              >
                Min
              </TableSortLabel>
            </TableCell>
            <TableCell>
              <TableSortLabel
                active={orderBy === "bedroomsMax"}
                direction={orderBy === "bedroomsMax" ? order : "asc"}
                onClick={() => handleSort("bedroomsMax")}
              >
                Max
              </TableSortLabel>
            </TableCell>

            <TableCell>
              <TableSortLabel
                active={orderBy === "bathroomsMin"}
                direction={orderBy === "bathroomsMin" ? order : "asc"}
                onClick={() => handleSort("bathroomsMin")}
              >
                Min
              </TableSortLabel>
            </TableCell>
            <TableCell>
              <TableSortLabel
                active={orderBy === "bathroomsMax"}
                direction={orderBy === "bathroomsMax" ? order : "asc"}
                onClick={() => handleSort("bathroomsMax")}
              >
                Max
              </TableSortLabel>
            </TableCell>

            <TableCell />
            <TableCell />
            <TableCell />
            <TableCell />
            <TableCell />
            <TableCell />
          </TableRow>
        </TableHead>

        <TableBody>
          {reports?.data?.map((row) => {
            return <PresaleRow key={row.id} row={row} />;
          })}
        </TableBody>
      </Table>
      <div className="card-inner" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
        {reports?.data?.length ? (
          <Pagination
            variant="outlined"
            shape="rounded"
            defaultPage={6}
            boundaryCount={2}
            count={reports?.total?.totalPages}
            page={reports?.total?.currentPage}
            onChange={(event, value) => {
              if (value === reports?.total?.currentPage) return;

              let payload = { ...reports?.localFilter, page: value };
              handleInventoryGet(payload);
            }}
          />
        ) : null}
      </div>
    </TableContainer>
  );
};

const PresaleRow = (props) => {
  const { row } = props;
  const [open, setOpen] = React.useState(false);
  let incentive = row.specialIncentives?.find((li) => {
    let isBefore = li?.end ? new Date(li?.end) > new Date() : true;
    let isAfter = new Date(li?.start) < new Date();

    if (li?.isSpecialIncentive && isBefore && isAfter) {
      return li;
    }
  });

  return (
    <React.Fragment>
      <TableRow>
        <TableCell>
          <div
            className="tb-product lazy-image"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <LazyLoadImage
              src={row?.images?.length ? `${process.env.REACT_APP_IMGURL}${row.images?.[0]}` : PlaceholderImg}
              alt="development_image"
              effect="blur"
              className="thumb"
              placeholderSrc={PlaceholderImg}
              style={{ maxWidth: "70px", borderRadius: "4px", objectFit: "contain" }}
            />
            <div style={{ display: "flex", flexDirection: "column", fontSize: "12px" }}>
              <div
                className="title"
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "2px",
                  fontSize: "14px",
                  fontWeight: "500",
                }}
              >
                {row?.name}
                <Link
                  to={`${process.env.REACT_APP_USER_WEB_URL}development/${row?.slug}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  <ImNewTab style={{ color: "#00aeff", marginLeft: "5px", fontSize: "14px" }} />
                </Link>
              </div>
              <span style={{ fontSize: "12px" }} className="sub-title">
                {row?.address?.firstLine}
              </span>
              <span style={{ fontSize: "12px" }} className="sub-title">
                {row?.address?.neighbourhood?.name}
              </span>
              <span style={{ fontSize: "12px" }} className="sub-title">
                {row?.user?.name
                  ? row?.user?.name
                  : row?.company?.company?.length
                  ? row?.company?.company?.[0]?.name
                  : "N/A"}
              </span>
            </div>
          </div>
        </TableCell>
        <TableCell>
          <div style={{ fontSize: "14px" }}>
            {row?.availableFloorPlans?.length ? (
              <>
                <span style={{ fontWeight: "500" }}>{row?.availableFloorPlans.length}</span> Floor Plans
                <IconButton aria-label="expand row" onClick={() => setOpen(!open)}>
                  {open ? <MdKeyboardArrowUp /> : <MdOutlineKeyboardArrowDown />}
                </IconButton>
              </>
            ) : null}
          </div>
        </TableCell>
        <TableCell>{row?.floorArea?.min ?? "N/A"}</TableCell>
        <TableCell>{row?.floorArea?.max ?? "N/A"}</TableCell>
        <TableCell>{row?.price?.price?.from ? USDollar(row?.price?.price?.from) : "N/A"}</TableCell>
        <TableCell>{row?.price?.price?.to ? USDollar(row?.price?.price?.to) : "N/A"}</TableCell>
        <TableCell>{row?.price?.pricePerSqft?.from ? USDollar(row?.price?.pricePerSqft?.from) : "N/A"}</TableCell>
        <TableCell>{row?.price?.pricePerSqft?.to ? USDollar(row?.price?.pricePerSqft?.to) : "N/A"}</TableCell>
        <TableCell>
          {incentive ? (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "1px",
                fontSize: "14px",
              }}
            >
              <span>Yes</span>
              <Tooltip title={parser(incentive?.values ?? "")}>
                <IconButton>
                  <MdInfoOutline style={{ color: "#00aeff", marginLeft: "5px", fontSize: "16px" }} />
                </IconButton>
              </Tooltip>
            </div>
          ) : (
            "No"
          )}
        </TableCell>
        <TableCell align="">{row?.bedrooms?.min ?? "N/A"}</TableCell>
        <TableCell align="">{row?.bedrooms?.max ?? "N/A"}</TableCell>
        <TableCell align="">{row?.bathrooms?.min ?? "N/A"}</TableCell>
        <TableCell align="">{row?.bathrooms?.max ?? "N/A"}</TableCell>
        <TableCell>{row?.price?.deposit?.total ?? "N/A"}</TableCell>
        <TableCell>
          {row?.construction?.constructionEnd?.month
            ? `${row?.construction?.constructionEnd?.month}, ${row?.construction?.constructionEnd?.year}`
            : row?.construction?.constructionEnd?.year}
        </TableCell>
        <TableCell>
          {row?.vipAgentInformationFolder?.sellingCommision ? (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "1px",
                fontSize: "14px",
              }}
            >
              <span>Yes</span>
              <Tooltip title={parser(row?.vipAgentInformationFolder?.sellingCommision ?? "")}>
                <IconButton>
                  <MdInfoOutline style={{ color: "#00aeff", marginLeft: "5px", fontSize: "16px" }} />
                </IconButton>
              </Tooltip>
            </div>
          ) : (
            "No"
          )}
        </TableCell>
        <TableCell>
          <ul>
            <li>{row?.presentationCenter?.contact}</li>
            {row?.presentationCenter?.emailPrimary && <li>{row?.presentationCenter?.emailPrimary}</li>}
            {row?.presentationCenter?.mobilePrimary && <li>{row?.presentationCenter?.mobilePrimary}</li>}
            {row?.presentationCenter?.emailSecondary && <li>{row?.presentationCenter?.emailSecondary}</li>}
            {row?.presentationCenter?.mobileSecondary && <li>{row?.presentationCenter?.mobileSecondary}</li>}
          </ul>
        </TableCell>
      </TableRow>

      {row?.availableFloorPlans?.length ? (
        <TableRow>
          <TableCell colSpan={11}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box sx={{ margin: 1 }}>
                <Typography variant="h6" gutterBottom component="div">
                  Floor Plans
                </Typography>
                <Table aria-label="floorplans">
                  <TableHead>
                    <TableRow>
                      <TableCell>Name</TableCell>
                      {/* <TableCell>Status</TableCell> */}
                      <TableCell>Home Type</TableCell>
                      <TableCell>Home Style</TableCell>
                      <TableCell>Bedrooms</TableCell>
                      <TableCell>Bathrooms</TableCell>
                      <TableCell>Size</TableCell>
                      <TableCell>Price</TableCell>
                      <TableCell>Balcony</TableCell>
                      <TableCell>Parking</TableCell>
                      <TableCell>Garage Layout</TableCell>
                      <TableCell>Rooftop Deck</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {row?.availableFloorPlans?.map((fplan) => (
                      <TableRow key={fplan._id}>
                        <TableCell component="th" scope="row">
                          {fplan.title}
                        </TableCell>
                        {/* <TableCell style={{ textTransform: "capitalize" }}>{fplan.status}</TableCell> */}
                        <TableCell>{fplan?.homeType?.name ? fplan?.homeType.name : "N/A"}</TableCell>
                        <TableCell>{fplan?.type?.name ? fplan?.type.name : "N/A"}</TableCell>
                        <TableCell>{fplan?.bedrooms ?? "N/A"}</TableCell>
                        <TableCell>{fplan?.bathrooms ?? "N/A"}</TableCell>
                        <TableCell>
                          {fplan?.size?.range
                            ? `${fplan?.size?.from} - ${fplan?.size?.to} sqft`
                            : `${fplan?.size?.size} sqft`}
                        </TableCell>
                        <TableCell>
                          {fplan?.price?.range
                            ? `${USDollar(fplan?.price?.from)} - ${USDollar(fplan?.price?.to)}`
                            : fplan?.price?.price
                            ? `${USDollar(fplan?.price?.price)}`
                            : "N/A"}
                        </TableCell>
                        <TableCell>
                          {fplan?.balcony?.range
                            ? `${fplan?.balcony?.from} - ${fplan?.balcony?.to} sqft`
                            : fplan?.balcony?.size
                            ? `${fplan?.balcony?.size} sqft`
                            : "N/A"}
                        </TableCell>
                        <TableCell>
                          {fplan?.parking?.length ? (
                            <ul>
                              {fplan?.parking?.map((space, index) => (
                                <li key={index}>{space?.name}</li>
                              ))}
                            </ul>
                          ) : (
                            "N/A"
                          )}
                        </TableCell>
                        <TableCell>{fplan?.garageLayout?.name ?? "N/A"}</TableCell>
                        <TableCell>{fplan?.rooftopDeck ? "Yes" : "No"}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      ) : null}
    </React.Fragment>
  );
};

export const AssignmentTable = ({ order, orderBy, handleSort, handleInventoryGet }) => {
  const mainDivRef = useRef(null);

  const { reports } = useSelector((state) => ({
    reports: state.report.inventoryReport,
  }));

  return (
    <TableContainer component={Paper}>
      <Table
        sx={{ minWidth: 664 }}
        aria-label="simple table"
        responsive
        ref={mainDivRef}
        className={styles.presaleTable}
      >
        <TableHead>
          <TableRow>
            <TableCell sx={{ minWidth: 300 }}>Title</TableCell>
            {/* <TableCell sx={{ minWidth: 200 }} rowSpan={1}>
                      Floor Plan
                    </TableCell> */}
            <TableCell sx={{ minWidth: 200 }}>Community</TableCell>
            <TableCell sx={{ minWidth: 125 }} rowSpan={1}>
              <TableSortLabel
                active={orderBy === "floorArea"}
                direction={orderBy === "floorArea" ? order : "asc"}
                onClick={() => handleSort("floorArea")}
              >
                Floor Area
              </TableSortLabel>
            </TableCell>
            <TableCell sx={{ minWidth: 100 }} rowSpan={1}>
              <TableSortLabel
                active={orderBy === "bedrooms"}
                direction={orderBy === "bedrooms" ? order : "asc"}
                onClick={() => handleSort("bedrooms")}
              >
                Beds
              </TableSortLabel>
            </TableCell>
            <TableCell sx={{ minWidth: 100 }} rowSpan={1}>
              <TableSortLabel
                active={orderBy === "bathrooms"}
                direction={orderBy === "bathrooms" ? order : "asc"}
                onClick={() => handleSort("bathrooms")}
              >
                Baths
              </TableSortLabel>
            </TableCell>
            <TableCell sx={{ minWidth: 100 }} rowSpan={1}>
              <TableSortLabel
                active={orderBy === "parking"}
                direction={orderBy === "parking" ? order : "asc"}
                onClick={() => handleSort("parking")}
              >
                Parking
              </TableSortLabel>
            </TableCell>
            <TableCell sx={{ minWidth: 100 }} rowSpan={1}>
              <TableSortLabel
                active={orderBy === "asking"}
                direction={orderBy === "asking" ? order : "asc"}
                onClick={() => handleSort("asking")}
              >
                Asking
              </TableSortLabel>
            </TableCell>
            {/* <TableCell sx={{ minWidth: 100 }} rowSpan={1}>
              <TableSortLabel
                active={orderBy === "pricePerSqft"}
                direction={orderBy === "pricePerSqft" ? order : "asc"}
                onClick={() => handleSort("pricePerSqft")}
              >
                Price/Sqft
              </TableSortLabel>
            </TableCell> */}
            <TableCell sx={{ minWidth: 100 }} rowSpan={1}>
              Cost
            </TableCell>
            <TableCell sx={{ minWidth: 100 }} rowSpan={1}>
              <TableSortLabel
                active={orderBy === "hotSale"}
                direction={orderBy === "hotSale" ? order : "asc"}
                onClick={() => handleSort("hotSale")}
              >
                Hot
              </TableSortLabel>
            </TableCell>
            <TableCell sx={{ minWidth: 150 }} rowSpan={1}>
              Incentive
            </TableCell>
            <TableCell sx={{ minWidth: 100 }} rowSpan={1}>
              <TableSortLabel
                active={orderBy === "completion"}
                direction={orderBy === "completion" ? order : "asc"}
                onClick={() => handleSort("completion")}
              >
                Completion
              </TableSortLabel>
            </TableCell>
            <TableCell sx={{ minWidth: 200 }} rowSpan={1}>
              Commission
            </TableCell>
            <TableCell sx={{ minWidth: 100 }} rowSpan={1}>
              Contact
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {reports?.data?.map((row) => {
            let constructionEnd = row?.construction?.end?.month
              ? `${row?.construction?.end?.month}, ${row?.construction?.end?.year}`
              : row?.construction?.end?.year;
            let cost = extractNumber(row?.realtorRemarks?.originalPurchasePrice);

            return (
              <TableRow key={row._id}>
                <TableCell>
                  <div
                    className="tb-product lazy-image"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <LazyLoadImage
                      src={row?.images?.length ? `${process.env.REACT_APP_IMGURL}${row.images?.[0]}` : PlaceholderImg}
                      alt="development_image"
                      effect="blur"
                      className="thumb"
                      placeholderSrc={PlaceholderImg}
                      style={{ maxWidth: "70px", borderRadius: "4px", objectFit: "contain" }}
                    />
                    <div style={{ display: "flex", flexDirection: "column", fontSize: "12px" }}>
                      <div
                        className="title"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "2px",
                          fontSize: "14px",
                          fontWeight: "500",
                        }}
                      >
                        <span>{row?.title}</span>
                        <Link
                          to={`${process.env.REACT_APP_USER_WEB_URL}assignment/${row?.slug}`}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <ImNewTab style={{ color: "#00aeff", marginLeft: "5px", fontSize: "14px" }} />
                        </Link>
                      </div>
                      <span style={{ fontSize: "12px" }} className="sub-title">
                        {row?.address?.firstLine}
                      </span>
                      <span style={{ fontSize: "12px" }} className="sub-title">
                        {row?.address?.neighbourhood?.name}
                      </span>
                    </div>
                  </div>
                </TableCell>
                <TableCell>{row?.development?.name ?? "N/A"}</TableCell>
                <TableCell>{row?.floorArea + " sqft" ?? "N/A"}</TableCell>
                <TableCell>{row?.bedrooms ?? "N/A"}</TableCell>
                <TableCell>{row?.bathrooms ?? "N/A"}</TableCell>
                <TableCell>{row?.homeFacts?.parking?.noOfParking ?? "N/A"}</TableCell>
                <TableCell>{row?.price?.askingPrice ? USDollar(row?.price?.askingPrice) : "N/A"}</TableCell>
                {/* <TableCell>{row?.price?.pricePerSqft ? USDollar(row?.price?.pricePerSqft) : "N/A"}</TableCell> */}
                <TableCell>{cost ? USDollar(cost) : "N/A"}</TableCell>
                <TableCell>
                  {row?.price?.hotSale ? <span style={{ color: "red", fontWeight: "500" }}>Yes</span> : "No"}
                </TableCell>
                <TableCell>{row?.price?.decoratingAllowance}</TableCell>
                <TableCell>{constructionEnd}</TableCell>
                <TableCell>{row?.realtorRemarks?.sellingAgentCommission}</TableCell>
                <TableCell>
                  <ul>
                    <li>
                      {row?.user?.firstName} {row?.user?.lastName}{" "}
                    </li>
                    {row?.user?.email && <li>{row?.user?.email}</li>}
                    {row?.user?.mobile && <li>{row?.user?.mobile}</li>}
                  </ul>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>

      <div className="card-inner" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
        {reports?.data?.length ? (
          <Pagination
            variant="outlined"
            shape="rounded"
            defaultPage={6}
            boundaryCount={2}
            count={reports?.total?.totalPages}
            page={reports?.total?.currentPage}
            onChange={(event, value) => {
              if (value === reports?.total?.currentPage) return;

              let payload = { ...reports?.localFilter, page: value };
              handleInventoryGet(payload);
            }}
          />
        ) : null}
      </div>
    </TableContainer>
  );
};

export default InventoryReport;
